import { FC } from 'react';
import { InputNumber } from 'antd';
import { TbArmchair2, TbChevronDown, TbChevronUp } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

export interface SeatQuantityInputProps {
    max?: number;
    min?: number;
    onChange: (value: number) => void;
    value: number;
}

const SeatQuantityInput: FC<SeatQuantityInputProps> = ({ max, min = 1, onChange, value }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <InputNumber
            controls={{ downIcon: <TbChevronDown size='0.75rem' />, upIcon: <TbChevronUp size='0.75rem' /> }}
            max={max}
            min={min}
            onChange={(nextValue) => {
                if (typeof nextValue === 'number' && nextValue >= min) {
                    onChange(nextValue);
                }
            }}
            prefix={<TbArmchair2 style={{ color: token.colorTextTertiary, marginRight: 6 }} />}
            step={1}
            value={value}
        />
    );
};

export default SeatQuantityInput;
